import React from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { House03Icon } from '@hugeicons/core-free-icons';

function SingleFamily(props) {
    const fill = props.fill;
    const className = props.className;
    const size = props.size
    return (
        <HugeiconsIcon
            icon={House03Icon}
            className={className}
            color={fill}
            size={size}
        />
    )
}

export default SingleFamily;